import Loading from '@/shared/components/Carregando';
import MyContext from '@/shared/contexts/AppContext';
import { AttendanceSheetsTable } from '../perMonth/PerMonthTable';
import { AttendanceSheetsModals } from '../perMonth/PerMonthModals';
import { useAttendanceSheetsPendencias } from '@/modules/business/attendance-sheet/presentation/pages/pendencias/usePendencias';
import { useContext } from 'react';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';

export function AttendanceSheetsPendenciasPage() {
  const context = useContext(MyContext);
  if (!context)
    throw new Error('Contexto deve ser usado dentro de um Provedor.');

  const tableState = useDataTableState('estagiario.nome');

  const {
    registros,
    handleBuscar,
    permissaoExcluirFolhas,
    selectedItem,
    setSelectedItem,
    folhaSelecionada,
    setFolhaSelecionada,
    showModalCriarFolha,
    setShowModalCriarFolha,
    showModalCriarFolhas,
    setShowModalCriarFolhas,
    showModalNotificacaoIndividual,
    setShowModalNotificacaoIndividual,
    showModalNotificacoes,
    setShowModalNotificacoes,
    showModalResponsavel,
    setShowModalResponsavel,
    showModalAssinaturas,
    setShowModalAssinaturas,
    folhaParaAssinaturas,
    setFolhaParaAssinaturas,
    loaded,
  } = useAttendanceSheetsPendencias(tableState);

  if (!loaded) return <Loading />;

  return (
    <>
      <div className="mt-5">
      </div>

      {registros && (
        <AttendanceSheetsTable
          registros={registros}
          tableState={tableState}
          handleBuscar={handleBuscar}
          setSelectedItem={setSelectedItem}
          setShowModalCriarFolha={setShowModalCriarFolha}
          setFolhaSelecionada={setFolhaSelecionada}
          setShowModalResponsavel={setShowModalResponsavel}
          setShowModalNotificacaoIndividual={setShowModalNotificacaoIndividual}
          setFolhaParaAssinaturas={setFolhaParaAssinaturas}
          setShowModalAssinaturas={setShowModalAssinaturas}
          permissaoExcluirFolhas={permissaoExcluirFolhas}
        />
      )}

      <AttendanceSheetsModals
        folhaSelecionada={folhaSelecionada}
        selectedItem={selectedItem}
        showModalResponsavel={showModalResponsavel}
        setShowModalResponsavel={setShowModalResponsavel}
        showModalNotificacaoIndividual={showModalNotificacaoIndividual}
        setShowModalNotificacaoIndividual={setShowModalNotificacaoIndividual}
        showModalCriarFolha={showModalCriarFolha}
        setShowModalCriarFolha={setShowModalCriarFolha}
        showModalCriarFolhas={showModalCriarFolhas}
        setShowModalCriarFolhas={setShowModalCriarFolhas}
        showModalNotificacoes={showModalNotificacoes}
        setShowModalNotificacoes={setShowModalNotificacoes}
        isExecuting={false}
        handleCriarFolha={() => setShowModalCriarFolha(false)}
        handleGenerateAttendanceSheetsForMonth={async () => setShowModalCriarFolhas(false)}
        registros={registros}
        mesBusca={new Date()}
        showModalAssinaturas={showModalAssinaturas}
        setShowModalAssinaturas={setShowModalAssinaturas}
        folhaParaAssinaturas={folhaParaAssinaturas}
      />
    </>
  );
}

